<h3 mat-dialog-title> {{ data.title }}</h3>
<mat-dialog-content>
    <ng-container *ngFor="let legend of data.legend">
        <div class="legend-container">
			<div class="legend-color" [style.backgroundColor]="legend.color"> </div>
			<div class="legend-text">{{legend.text}}</div>
		</div>
    </ng-container>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button [mat-dialog-close]="" cdkFocusInitial>Close</button>
</mat-dialog-actions>